import React, { useEffect, useState } from 'react';
import { MessageCircle, X, MessageSquare } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [showTeaser, setShowTeaser] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isOpen) setShowTeaser(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, [isOpen]);
  return <div className="fixed bottom-24 md:bottom-8 right-4 md:right-8 z-50 flex flex-col items-end" data-id="element-6">
      <AnimatePresence data-id="element-7">
        {showTeaser && !isOpen && <motion.div initial={{
        opacity: 0,
        y: 10,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.9,
        transition: {
          duration: 0.2
        }
      }} className="bg-white text-navy px-4 py-3 rounded-2xl rounded-br-none shadow-lg border border-gray-100 mb-4 max-w-[250px] cursor-pointer relative" onClick={() => {
        setIsOpen(true);
        setShowTeaser(false);
      }} data-id="element-8">
            <p className="text-sm font-medium pr-4" data-id="element-9">
              Hi! Need an electrician? Text us for a quick quote 💬
            </p>
            <button className="absolute -top-2 -right-2 bg-gray-100 text-gray-500 rounded-full p-1 hover:bg-gray-200" onClick={e => {
          e.stopPropagation();
          setShowTeaser(false);
        }} data-id="element-10">
              <X className="w-3 h-3" data-id="element-11" />
            </button>
          </motion.div>}
      </AnimatePresence>

      <AnimatePresence data-id="element-12">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} className="bg-white rounded-2xl shadow-2xl border border-gray-100 w-[300px] mb-4 overflow-hidden" data-id="element-13">
            <div className="bg-[#25D366] p-4 text-white flex justify-between items-center" data-id="element-14">
              <div data-id="element-15">
                <h3 className="font-bold text-lg" data-id="element-16">
                  Chat with Completely Electrical
                </h3>
                <p className="text-xs text-white/80" data-id="element-17">
                  Typically replies in minutes
                </p>
              </div>
              <button onClick={() => setIsOpen(false)} className="text-white/80 hover:text-white" data-id="element-18">
                <X className="w-5 h-5" data-id="element-19" />
              </button>
            </div>
            <div className="p-4 bg-gray-50 h-[200px] flex flex-col gap-3 overflow-y-auto" data-id="element-20">
              <div className="bg-white border border-gray-100 p-3 rounded-2xl rounded-tl-none shadow-sm max-w-[85%]" data-id="element-21">
                <p className="text-sm text-slate" data-id="element-22">
                  Hello! How can we help you today?
                </p>
              </div>
            </div>
            <div className="p-4 bg-white border-t border-gray-100 flex flex-col gap-2" data-id="element-23">
              <a href="sms:0418381988" className="w-full bg-gray-100 hover:bg-gray-200 text-navy py-2.5 rounded-xl text-sm font-bold flex items-center justify-center gap-2 transition-colors" data-id="element-24">
                <MessageSquare className="w-4 h-4" data-id="element-25" />
                Text Us (SMS)
              </a>
              <a href="https://wa.me/61418381988" target="_blank" rel="noopener noreferrer" className="w-full bg-[#25D366] hover:bg-[#20bd5a] text-white py-2.5 rounded-xl text-sm font-bold flex items-center justify-center gap-2 transition-colors" data-id="element-26">
                <MessageCircle className="w-4 h-4" data-id="element-27" />
                WhatsApp
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>

      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={() => {
      setIsOpen(!isOpen);
      setShowTeaser(false);
    }} className="w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow relative" data-id="element-28">
        {isOpen ? <X className="w-6 h-6" data-id="element-29" /> : <MessageCircle className="w-6 h-6" data-id="element-30" />}
        {!isOpen && <span className="absolute top-0 right-0 flex h-3 w-3" data-id="element-31">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-32"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500 border-2 border-white" data-id="element-33"></span>
          </span>}
      </motion.button>
    </div>;
}